<template>
  <div>
    <TopNavBar navtitle="查看考生评语"></TopNavBar>
    <van-button type="primary" v-if="ERT_Name != ''" @click="printTable"
      >打印评语</van-button
    >
    <table class="SRcontainer" style="border-collapse: collapse" border="1">
      <tbody>
        <tr style="">
          <td style="text-align: center" colspan="10" class="SRht">
            中国音协音乐考级委员会{{
              UserInfo ? UserInfo.Majors.MName : ""
            }}考级评审表
          </td>
        </tr>
        <tr style="">
          <td style="width: 12%">考生姓名</td>
          <td style="width: 21.3%" colspan="3">
            {{ UserInfo ? UserInfo.Name : "" }}
          </td>
          <td style="width: 12%">准考证号</td>
          <td style="width: 21.3%" colspan="2">
            {{ UserInfo ? UserInfo.ExamNO : "" }}
          </td>
          <td style="width: 12%">报考等级</td>
          <td style="width: 21.3%" colspan="2">
            {{ UserInfo ? UserInfo.Grades.GName : "" }}
          </td>
        </tr>
        <tr style="">
          <td style="text-align: center" colspan="11" class="SRht2">
            考评项目及综合评价
          </td>
        </tr>
        <tr class="sitem">
          <td class="SRtitle">音准节奏</td>
          <td class="w9">
            好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['音准节奏'] &&
                  resultList.Judgement['综合评审']['音准节奏'][0] == '好'
              "
            />
          </td>
          <td class="w9">
            较好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['音准节奏'] &&
                  resultList.Judgement['综合评审']['音准节奏'][0] == '较好'
              "
            />
          </td>
          <td class="w9">
            尚可
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['音准节奏'] &&
                  resultList.Judgement['综合评审']['音准节奏'][0] == '尚可'
              "
            />
          </td>
          <td class="w9">
            较差
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['音准节奏'] &&
                  resultList.Judgement['综合评审']['音准节奏'][0] == '较差'
              "
            />
          </td>
          <td class="SRtitle">情感表现</td>
          <td class="w9">
            好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['情感表现'] &&
                  resultList.Judgement['综合评审']['情感表现'][0] == '好'
              "
            />
          </td>
          <td class="w9">
            较好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['情感表现'] &&
                  resultList.Judgement['综合评审']['情感表现'][0] == '较好'
              "
            />
          </td>
          <td class="w9">
            尚可
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['情感表现'] &&
                  resultList.Judgement['综合评审']['情感表现'][0] == '尚可'
              "
            />
          </td>
          <td class="w9">
            较差
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['情感表现'] &&
                  resultList.Judgement['综合评审']['情感表现'][0] == '较差'
              "
            />
          </td>
        </tr>
        <tr class="sitem">
          <td class="SRtitle">发声吐字</td>
          <td class="w9">
            好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['发声吐字'] &&
                  resultList.Judgement['综合评审']['发声吐字'][0] == '好'
              "
            />
          </td>
          <td class="w9">
            较好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['发声吐字'] &&
                  resultList.Judgement['综合评审']['发声吐字'][0] == '较好'
              "
            />
          </td>
          <td class="w9">
            尚可
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['发声吐字'] &&
                  resultList.Judgement['综合评审']['发声吐字'][0] == '尚可'
              "
            />
          </td>
          <td class="w9">
            较差
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['发声吐字'] &&
                  resultList.Judgement['综合评审']['发声吐字'][0] == '较差'
              "
            />
          </td>
          <td class="SRtitle">仪态修养</td>
          <td class="w9">
            好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['仪态修养'] &&
                  resultList.Judgement['综合评审']['仪态修养'][0] == '好'
              "
            />
          </td>
          <td class="w9">
            较好
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['仪态修养'] &&
                  resultList.Judgement['综合评审']['仪态修养'][0] == '较好'
              "
            />
          </td>
          <td class="w9">
            尚可
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['仪态修养'] &&
                  resultList.Judgement['综合评审']['仪态修养'][0] == '尚可'
              "
            />
          </td>
          <td class="w9">
            较差
            <van-icon
              name="passed"
              v-if="
                resultList.Judgement['综合评审']['仪态修养'] &&
                  resultList.Judgement['综合评审']['仪态修养'][0] == '较差'
              "
            />
          </td>
        </tr>
        <tr style="height: 120px">
          <td>评审意见</td>
          <td colspan="9">
            {{
              resultList.Judgement &&
              resultList.Judgement["意见建议"] &&
              resultList.Judgement["意见建议"]["意见与建议"]
                ? resultList.Judgement["意见建议"]["意见与建议"].join(",")
                : ""
            }}{{ resultList.Suggestion }}
          </td>
        </tr>
        <tr>
          <td>综审意见</td>
          <td style="text-align: left" colspan="7">{{ ERT_Name }}</td>
          <td style="text-align: center" colspan="2">
            {{
              resultList.CreateTime
                ? `${new Date(resultList.CreateTime).getFullYear()}年${new Date(
                    resultList.CreateTime
                  ).getMonth() + 1}月`
                : ""
            }}
          </td>
        </tr>
      </tbody>
    </table>

    <div id="printTable" style="width:960px;display:none;background-color:#FFF">
      <table class="SRcontainer" style="border-collapse: collapse" border="1">
        <tbody>
          <tr style="">
            <td style="text-align: center" colspan="10" class="SRht">
              中国音协音乐考级委员会{{
                UserInfo ? UserInfo.Majors.MName : ""
              }}考级评审表
            </td>
          </tr>
          <tr style="">
            <td style="width: 12%">考生姓名</td>
            <td style="width: 21.3%" colspan="3">
              {{ UserInfo ? UserInfo.Name : "" }}
            </td>
            <td style="width: 12%">准考证号</td>
            <td style="width: 21.3%" colspan="2">
              {{ UserInfo ? UserInfo.ExamNO : "" }}
            </td>
            <td style="width: 12%">报考等级</td>
            <td style="width: 21.3%" colspan="2">
              {{ UserInfo ? UserInfo.Grades.GName : "" }}
            </td>
          </tr>
          <tr style="">
            <td style="text-align: center" colspan="11" class="SRht2">
              考评项目及综合评价
            </td>
          </tr>
          <tr class="sitem">
            <td class="SRtitle">音准节奏</td>
            <td class="w9">
              好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['音准节奏'] &&
                    resultList.Judgement['综合评审']['音准节奏'][0] == '好'
                "
              />
            </td>
            <td class="w9">
              较好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['音准节奏'] &&
                    resultList.Judgement['综合评审']['音准节奏'][0] == '较好'
                "
              />
            </td>
            <td class="w9">
              尚可<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['音准节奏'] &&
                    resultList.Judgement['综合评审']['音准节奏'][0] == '尚可'
                "
              />
            </td>
            <td class="w9">
              较差<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['音准节奏'] &&
                    resultList.Judgement['综合评审']['音准节奏'][0] == '较差'
                "
              />
            </td>
            <td class="SRtitle">情感表现</td>
            <td class="w9">
              好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['情感表现'] &&
                    resultList.Judgement['综合评审']['情感表现'][0] == '好'
                "
              />
            </td>
            <td class="w9">
              较好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['情感表现'] &&
                    resultList.Judgement['综合评审']['情感表现'][0] == '较好'
                "
              />
            </td>
            <td class="w9">
              尚可<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['情感表现'] &&
                    resultList.Judgement['综合评审']['情感表现'][0] == '尚可'
                "
              />
            </td>
            <td class="w9">
              较差<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['情感表现'] &&
                    resultList.Judgement['综合评审']['情感表现'][0] == '较差'
                "
              />
            </td>
          </tr>
          <tr class="sitem">
            <td class="SRtitle">发声吐字</td>
            <td class="w9">
              好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['发声吐字'] &&
                    resultList.Judgement['综合评审']['发声吐字'][0] == '好'
                "
              />
            </td>
            <td class="w9">
              较好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['发声吐字'] &&
                    resultList.Judgement['综合评审']['发声吐字'][0] == '较好'
                "
              />
            </td>
            <td class="w9">
              尚可<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['发声吐字'] &&
                    resultList.Judgement['综合评审']['发声吐字'][0] == '尚可'
                "
              />
            </td>
            <td class="w9">
              较差<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['发声吐字'] &&
                    resultList.Judgement['综合评审']['发声吐字'][0] == '较差'
                "
              />
            </td>
            <td class="SRtitle">仪态修养</td>
            <td class="w9">
              好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['仪态修养'] &&
                    resultList.Judgement['综合评审']['仪态修养'][0] == '好'
                "
              />
            </td>
            <td class="w9">
              较好<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['仪态修养'] &&
                    resultList.Judgement['综合评审']['仪态修养'][0] == '较好'
                "
              />
            </td>
            <td class="w9">
              尚可<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['仪态修养'] &&
                    resultList.Judgement['综合评审']['仪态修养'][0] == '尚可'
                "
              />
            </td>
            <td class="w9">
              较差<br />
              <van-icon
                name="passed"
                v-if="
                  resultList.Judgement['综合评审']['仪态修养'] &&
                    resultList.Judgement['综合评审']['仪态修养'][0] == '较差'
                "
              />
            </td>
          </tr>
          <tr style="height: 120px">
            <td>评审意见</td>
            <td colspan="9">
              {{
                resultList.Judgement &&
                resultList.Judgement["意见建议"] &&
                resultList.Judgement["意见建议"]["意见与建议"]
                  ? resultList.Judgement["意见建议"]["意见与建议"].join(",")
                  : ""
              }}{{ resultList.Suggestion }}
            </td>
          </tr>
          <tr>
            <td>综审意见</td>
            <td style="text-align: left" colspan="7">{{ ERT_Name }}</td>
            <td style="text-align: center" colspan="2">
              {{
                resultList.CreateTime
                  ? `${new Date(
                      resultList.CreateTime
                    ).getFullYear()}年${new Date(
                      resultList.CreateTime
                    ).getMonth() + 1}月`
                  : ""
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { ExaminerReviewInfo } from "@/api/exam";
import domtoimage from "dom-to-image";
import { Toast, ImagePreview } from "vant";
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      EF_ID: "",
      CertNO: "",
      resultList: {},
      UserInfo: null,
      ExamAnswerSheets: null,
      resultCode: [
        { ERT_Code: 4, ERT_Name: "优秀" },
        { ERT_Code: 3, ERT_Name: "良好" },
        { ERT_Code: 2, ERT_Name: "及格" },
        { ERT_Code: 1, ERT_Name: "不及格" },
        { ERT_Code: 0, ERT_Name: "缺考" }
      ],
      ERT_Name: ""
    };
  },
  created() {
    this.GetExamList();
  },
  methods: {
    GetExamList() {
      if (
        this.$route.query.EF_ID != undefined &&
        this.$route.query.EF_ID > 0 &&
        this.$route.query.CertNO != undefined &&
        this.$route.query.CertNO
      ) {
        ExaminerReviewInfo({
          EF_ID: this.$route.query.EF_ID,
          CertNO: this.$route.query.CertNO
        }).then(result => {
          console.log("🚀 ~ ExaminerReviewInfo ~ result:", result.item);
          this.resultList = result.item;
          this.resultList.Judgement = JSON.parse(this.resultList.Judgement);
          this.UserInfo = result.OtherMsg.UserInfo;
          this.ERT_Name = this.resultCode.filter(
            s => s.ERT_Code == result.OtherMsg.ERT_Code
          )[0].ERT_Name;
        });
      } else {
        if (window.history.length <= 1) {
          return;
        }
        if (
          this.$router.history.current.meta.BackUrl &&
          this.$router.history.current.meta.BackUrl !== ""
        ) {
          this.$router.push(
            { name: this.$router.history.current.meta.BackUrl },
            () => {},
            () => {}
          );
        } else {
          this.$router.go(-1); //返回上一层
        }
      }
    },
    sortIdAsc() {
      return function(a, b) {
        var value1 = a.ExamQuestionType.Sort;
        var value2 = b.ExamQuestionType.Sort;
        return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      };
    },
    printTable() {
      let node = document.getElementById("printTable");
      node.style.display = "block";
      domtoimage
        .toPng(node)
        .then(dataUrl => {
          console.log(dataUrl);
          node.style.display = "none";
          ImagePreview({
            images: [dataUrl],
            closeable: true
          });
        })
        .catch(function(error) {
          Toast.fail("生成评语失败，请稍后再试");
          node.style.display = "none";
        });
    }
  }
};
</script>

<style>
.SRcontainer {
  width: 96%;
  margin: 2%;
  box-sizing: border-box;
  background: #fff;
}
.SRht {
  font-size: 28px;
  font-weight: bold;
}
.SRht2 {
  font-size: 18px;
  letter-spacing: 20px;
}
.SRcontainer tr td {
  padding: 5px;
  font-size: 14px;
}
.SRcontainer tr td .van-icon {
  color: #ee0a24;
  font-size: 24px;
}
.SRcontainer tr td {
  text-align: center;
  padding: 15px 0;
}
.SRcontainer .sitem .SRtitle {
  background: #fff;
  color: #333;
  font-weight: bold;
}
.succeed {
  background: #07c160;
  color: #fff;
}
.warning {
  background: #ff976a;
  color: #fff;
}
.danger {
  background: #ee0a24;
  color: #fff;
}
.w9 {
  width: 9%;
}
</style>
